var map = {
	"./ar-AE.json": 9926,
	"./ar-EG.json": 7784,
	"./ar-OM.json": 443,
	"./ar-QA.json": 8910,
	"./en-AE.json": 676,
	"./en-EG.json": 5734,
	"./en-OM.json": 8066,
	"./en-QA.json": 1087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9990;